import { render, staticRenderFns } from "./EmployeeLeaveDetails.vue?vue&type=template&id=bafc2cdc"
import script from "./EmployeeLeaveDetails.vue?vue&type=script&lang=js"
export * from "./EmployeeLeaveDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports